/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

var _Item, _Item2, _Item3;
function Item() {
  const prefix = usePrefix();
  return /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--breadcrumb-item`
  }, /*#__PURE__*/React__default.createElement("span", {
    className: `${prefix}--link`
  }, "\xA0"));
}
function BreadcrumbSkeleton(_ref) {
  let {
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const classes = cx(`${prefix}--breadcrumb`, `${prefix}--skeleton`, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, rest), _Item || (_Item = /*#__PURE__*/React__default.createElement(Item, null)), _Item2 || (_Item2 = /*#__PURE__*/React__default.createElement(Item, null)), _Item3 || (_Item3 = /*#__PURE__*/React__default.createElement(Item, null)));
}
BreadcrumbSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string
};

export { BreadcrumbSkeleton, BreadcrumbSkeleton as default };
